<template>
    <v-card>
        <div class="modal">
            <div class="modal-content" style="width: 100%;">
                <s-toolbar label="IMPRESIÓN DE CONTRATOS PREVIOS" dark :color="'#BAB6B5'" close @close="$emit('close')"
                    class="" print @print="downloadPdf()"></s-toolbar>
                <vue-html2pdf :htmlToPdfOptions="htmlToPdfOptions" :show-layout="true" :float-layout="false"
                    :enable-download="false" :preview-modal="false" :filename="`${form.Document}.pdf`" pdf-format="a4"
                    pdf-orientation="portrait" pdf-content-width="100%" :manual-pagination="true" :margin="1"
                    @beforeDownload="beforeDownload($event)" :autoPaging="true" ref="html2Pdf">
                    <section slot="pdf-content">
                        <div class="pdf-page">
                            <!-- Cabecera -->
                            <div style="width: 100%; padding: 0.75cm 1.5cm;box-sizing: border-box;">
                                <table style="width: 100%; display: table; border-collapse: collapse;">
                                    <tr>
                                        <td class="p-3" style="text-align: left;">
                                            <img src="../../../../public/static/logo_sp.png" alt="Logo" width="160px" />
                                        </td>
                                        <td class="p-3 border text-right font-semibold" width="250px"
                                            style="padding-right: 15px!important;">
                                            FICHA DE DATOS DEL PERSONAL</td>
                                    </tr>
                                </table>

                                <table class="text-center border"
                                    style="width: 100%;display: table; border-collapse: separate; border-spacing: 0px 12px; border: none; font-size: 1rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-3 font-semibold" style="background: #ddd;" colspan="6">
                                            DATOS PERSONALES
                                        </td>
                                    </tr>

                                    <!-- DNI & NOMBRES -->
                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            DNI
                                        </td>
                                        <td class="p-2 text-uppercase border text-left">
                                            {{ form.Document }}
                                        </td>
                                        <td class="p-2 font-semibold text-left" colspan="2">
                                            APELLIDOS Y NOMBRES
                                        </td>
                                        <td class="p-2 border text-left" colspan="2">
                                            {{ form.Name }}
                                        </td>
                                    </tr>

                                    <!-- Dirección -->
                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            DIRECCION
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="5">
                                            {{ form.Address }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="p-2 font-semibold text-left" style="width: 90px;">
                                            DISTRITO
                                        </td>
                                        <td class="p-2 border text-left" style="width: 120px;">
                                            {{ form.District }}
                                        </td>
                                        <td class="p-2 font-semibold text-left" style="width: 90px;">
                                            PROVINCIA
                                        </td>
                                        <td class="p-2 border text-left" style="width: 120px;">
                                            {{ form.Province }}
                                        </td>
                                        <td class="p-2 font-semibold text-left" style="width: 120px;">
                                            DEPARTAMENTO
                                        </td>
                                        <td class="p-2 border text-left">
                                            {{ form.Department }}
                                        </td>
                                    </tr>
                                </table>

                                <!-- DATOS CAMPAÑA -->
                                <table class="text-center border"
                                    style="width: 100%;display: table; border-collapse: separate; border-spacing: 0px 12px; border: none; font-size: 1rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-3 font-semibold" style="background: #ddd;" colspan="6">
                                            CAMPAÑA : {{ form.Campaign }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            F. INICIO
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ $fun.formatDateView(form.CampaignStartDate) }}
                                        </td>
                                        <td class="p-2 font-semibold text-left">
                                            F. FIN
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ $fun.formatDateView(form.CampaignEndDate) }}
                                        </td>
                                    </tr>
                                </table>

                                <!-- OCUPACIÓN -->
                                <table class="text-center border"
                                    style="width: 100%;display: table; border-collapse: separate; border-spacing: 0px 12px; border: none; font-size: 1rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-3 font-semibold" style="background: #ddd;" colspan="6">
                                            DATOS LABORALES
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            OCUPACIÓN
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ form.Occupation }}
                                        </td>
                                        <td class="p-2 font-semibold text-left">
                                            CARGO DEL JEFE
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ form.SupervisorPosition }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            GERENCIA
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ form.Management }}
                                        </td>
                                        <td class="p-2 font-semibold text-left">
                                            AREA
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;" colspan="2">
                                            {{ form.Area }}
                                        </td>
                                    </tr>

                                    <!-- TIEMPO LABORAL -->
                                    <tr>
                                        <td class="p-2 font-semibold text-left">
                                            MONTO
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;">
                                            {{ form.Amount }}
                                        </td>
                                        <td class="p-2 font-semibold text-center">
                                            INICIO
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;">
                                            {{ $fun.formatDateView(form.FromDate) }}
                                        </td>
                                        <td class="p-2 font-semibold text-center">
                                            FIN
                                        </td>
                                        <td class="p-2 border text-left" style="text-transform: uppercase;">
                                            {{ $fun.formatDateView(form.ToDate) }}
                                        </td>
                                    </tr>
                                </table>

                                <!-- FUNCIONES -->
                                <table class="text-center border"
                                    style="width: 100%;display: table; border-collapse: separate; border-spacing: 0px 12px; border: none; font-size: 1rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-3 font-semibold" style="background: #ddd;">
                                            FUNCIONES
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="p-2 text-left">
                                            <div v-html="formatList(form.Functions)"></div>
                                        </td>
                                    </tr>
                                </table>

                                <!-- FIRMA CONSENTIMIENTO -->
                                <table class="text-center"
                                    style="width: 100%;display: table; border-collapse: collapse; border: none; font-size: 1rem;margin-top: 5px;color: #000;">
                                    <tr>
                                        <td class="p-2 text-center">
                                            <div
                                                style="display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 80px auto 10px auto; max-width: max-content;">
                                                <div
                                                    style="width: 100%; height: 80px; display: flex; justify-content: center; align-items: center; position: absolute; top: -80px;">
                                                    <div style="width: 100%; display: flex;">
                                                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; cursor: pointer;"
                                                            @click="openSignatureDialog()">
                                                            <span v-if="!SignaturePatient && !SignaturePatientDB"
                                                                style="height:80px; width: 100%;"></span>
                                                            <img :src="SignaturePatient" v-if="SignaturePatient"
                                                                alt="Firma Paciente"
                                                                style="min-width:150px;max-width: 100%; height: 80px; object-fit: cover;" />
                                                            <img :src="SignaturePatientDB"
                                                                v-if="!SignaturePatient && SignaturePatientDB"
                                                                alt="Firma Paciente"
                                                                style="min-width: 150px;max-width: 100%; height: 80px; object-fit: cover;" />
                                                        </div>
                                                        <div
                                                            style="width: 60px; height: 80px; border: 1px solid #000; text-align: center; display: flex; justify-content: center; align-items: center;">
                                                            <!-- fingerPrintPatient, fingerPrintPatientDB -->
                                                            <s-finger-print
                                                                v-if="FingerPrintPatientDB && !FingerPrintPatient"
                                                                contentIMG :srcImg="FingerPrintPatientDB" notBtn
                                                                :stylesDiv="{ width: '60px', height: '80px', cursor: 'pointer' }"
                                                                @fingerprintSaved="handleFingerprintPatient" />
                                                            <s-finger-print
                                                                v-if="!FingerPrintPatientDB && !FingerPrintPatient"
                                                                contentIMG notBtn
                                                                :stylesDiv="{ width: '60px', height: '80px', cursor: 'pointer' }"
                                                                @fingerprintSaved="handleFingerprintPatient" />
                                                            <s-finger-print v-if="FingerPrintPatient" contentIMG
                                                                :srcImg="FingerPrintPatient" notBtn
                                                                :stylesDiv="{ width: '60px', height: '80px', cursor: 'pointer' }"
                                                                @fingerprintSaved="handleFingerprintPatient" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <span style="border-top: 1px solid #000;">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <span style="font-weight: bold;">Nombre : </span>
                                                    {{ form.Name }}&nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>
                                                <span>
                                                    <span style="font-weight: bold;">DNI : </span>
                                                    {{ form.Document }}
                                                </span>
                                                <span>
                                                    <span style="font-weight: bold;">Fecha : </span>
                                                    {{ $fun.formatDateView(new Date()) }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="text-sm" style="padding: 0;margin: 0;">
                                            <b>NOMBRES : </b> {{ form.Name }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-sm" style="padding: 0;margin: 0;">
                                            <b>DNI : </b> {{ form.Document }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-sm" style="padding: 0;margin: 0;">
                                            <b>FECHA : </b> {{ $fun.formatDateView(new Date()) }}
                                        </td>
                                    </tr> -->
                                </table>
                            </div>
                        </div>
                    </section>
                </vue-html2pdf>
            </div>
        </div>

        <!-- Diálogo de firma paciente -->
        <v-dialog v-model="dialogSignaturePatient" max-width="800px" persistent>
            <v-card class="rounded-xl">
                <div class="modern-header">
                    <div class="header-content">
                        <div class="header-left">
                            <v-icon class="header-icon" size="28" color="white">mdi-lead-pencil</v-icon>
                            <h2 class="header-title" style="text-transform: uppercase;font-size: 1.2rem">
                                Firma del Trabajador
                            </h2>
                        </div>
                        <div class="header-actions">
                            <v-btn icon large class="close-btn" @click="dialogSignaturePatient = false">
                                <v-icon color="white">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <v-container>
                    <v-row>
                        <v-col>
                            <s-signature-pad ref="signaturePadPatient" style="height: 400px;" wacom
                                :wacomFullName="form.Name" @save-signature="handleSignaturePatient" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import sFingerPrint from '@/components/Utils/RecursosHm/sFingerPrint';
import _sHelper from "@/services/HelperService";

export default {
    name: "DeliveryPDF",
    props: {
        form: {
            type: Object,
            default: null,
        }
    },
    components: {
        VueHtml2pdf,
        sFingerPrint
    },
    data() {
        return {
            SignaturePatient: null,
            SignaturePatientDB: null,
            FingerPrintPatient: null,
            FingerPrintPatientDB: null,
            dialogSignaturePatient: false,
            items: [],
            htmlToPdfOptions: {
                filename: `${this.form.DocEntry}-${this.form.DocNum}.pdf`,
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'portrait'
                },
                html2canvas: {
                    useCORS: true,
                    scale: 9,
                },
            },
            headers: [
                { text: "Código Artículo", value: 'ArtCode' },
                { text: "Descripción", value: 'DerDescription' },
                { text: "Unidad de Medida", value: 'UnitMeasurement' },
                { text: "Cantidad", value: 'DerQuantity' },
                { text: "Centro de Costo", value: 'CceName' },
                { text: "Línea de Negocios", value: 'BslName' },
                { text: "Tipo Costo", value: 'TypeCostName' },
                { text: "Proyecto", value: 'PrjName' },
            ],
            groupedItems: [],
        }
    },
    methods: {
        openSignatureDialog() {
            this.dialogSignaturePatient = true;
        },
        handleFingerprintPatient(image) {
            this.FingerPrintPatient = image;
        },
        handleSignaturePatient(image) {
            this.SignaturePatient = image;
            this.dialogSignaturePatient = false;
            // console.log({image});
        },
        formatList(text) {
            if (!text) return '';
            const items = text.split('•').map(i => i.trim()).filter(i => i.length);

            return `<ul class="v-list v-list--dense pa-0 ma-0">
                ${items.map(i => `
                <li class="v-list-item pa-0 ma-0 text-left" style="font-size: 0.675rem;min-height: 20px !important;text-transform: uppercase;">
                   ${i}
                </li>`).join('')}
            </ul>`;
        },
        downloadPdf() {
            this.$refs.html2Pdf.generatePdf();
        },

        formatDate(date) {
            return this.$fun.formatDateTimeShort12HView(date)
                .replace("AM", "a.m.")
                .replace("PM", "p.m.")
        },
        groupItems(items, groupSize = 9) {
            const grouped = [];
            for (let i = 0; i < items.length; i += groupSize) {
                grouped.push(items.slice(i, i + groupSize));
            }
            return grouped;
        },
        beforeDownload({ html2pdf, options, pdfContent }) {
            console.log(`On Before PDF Generation`)
            this.htmlToPdfOptions.filename = `${this.form.Document}.pdf`;
            html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(10)
                    pdf.setTextColor(150)
                    pdf.text('Página ' + i + ' de ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                }
            }).save()
        },
        formatCurrency(value) {
            if (value === null || value === undefined) return ''
            return new Intl.NumberFormat('es-PE', {
                style: 'currency',
                currency: 'PEN',
                minimumFractionDigits: 2
            }).format(value)
        }
    },
    created() {
        console.log(this.form)
    },
}
</script>

<style>
.pdf-page {
    background: #fff;
    font-family: sans-serif;
    height: 297mm;
    /* Altura exacta de una página A4 */
    width: 210mm;
    /* Ancho de una página A4 */
    margin: 0 auto;
    position: relative;
    margin-bottom: 20px;
    /* Un margen extra entre páginas para evitar desbordamientos */

    page-break-inside: avoid;
    /* Evita que el div se divida entre páginas */
    width: 100%;
    height: 100%;
    /* Garantiza que cada div ocupe una página completa */
    min-width: 210mm;
}


.obs {
    width: 90%;
    margin: auto;
    font-size: 12px;
    page-break-inside: avoid;
    /* Evita divisiones en el contenido de observaciones */
}

.details-table thead {
    display: table-header-group;
}

.details-table tr {
    page-break-inside: avoid;

}

.details-table tbody tr {
    page-break-inside: avoid;
    margin-top: 10px;
}

.details-table {
    page-break-inside: auto;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
    margin-top: 10px;
    border-top: 4px double black;
    border-bottom: 4px double black;
}

.details-table th {
    border-bottom: 4px double black;
    text-align: center;
    padding: 8px;
}

.details-table td {
    text-align: center;
    padding: 8px;
}

.w-full {
    width: 100%;
}

.w-50 {
    width: 50%;
}

.p-1 {
    padding: 0.1rem;
}

.p-2 {
    padding: 0.2rem;
}

.p-3 {
    padding: 0.28rem;
}

.pr-1 {
    padding-right: 0.1rem;
}

.pl-1 {
    padding-left: 0.1rem;
}

.pl-2 {
    padding-left: 0.2rem;
}

.pr-2 {
    padding-right: 0.125rem;
}

.pl-4 {
    padding-left: 1rem;
}

.pl-5 {
    padding-left: 1.25rem;
}

.pr-4 {
    padding-right: 1rem;
}

.pr-5 {
    padding-right: 1.25rem;
}

.text-uppercase {
    text-transform: uppercase;
}

.font-semibold {
    font-weight: bold;
}

.text-sm {
    font-size: 0.875rem;
}

.text-xs {
    font-size: 0.725rem;
}

.text-10 {
    font-size: 0.625rem;
}

.text-9 {
    font-size: 0.525rem;
}

.text-8 {
    font-size: 0.425rem;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

.text-center {
    text-align: center;
}

.border {
    border: 1px solid #000;
}

.modal {
    /* display: flex; */
    /* justify-content: center;
    align-items: center; */
    position: relative;
    /* top: 0;
    left: 0; */
    width: 100%;
    height: 100%;
    /* margin: auto; */
    background-color: rgba(0, 0, 0, 0.5);
    /* z-index: 1000; */
}


.modal-content {
    /* background-color: #fff; */
    /* padding: 20mm; */
    /* border: 1px solid #000; */
}

.modern-header {
    background: linear-gradient(135deg, #606060 0%, #525c64 100%);
    padding: 12px;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.header-icon {
    background: rgba(255, 255, 255, 0.2);
    padding: 8px;
    border-radius: 12px;
    backdrop-filter: blur(10px);
}

.header-text,
.header-title {
    flex: 1;
}

.gradient-primary {
    background: linear-gradient(135deg, #a4a4a4 29%, #322d38 100%);
}

.header-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    width: 100%;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1 1 0%;
}

.header-right {
    display: flex;
    justify-items: center;
    align-items: center !important;
    min-width: 300px;
}
</style>